module.exports = __webpack_public_path__ + "static/media/descending.91cd5a16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/documentList/descending.svg
// module id = 741
// module chunks = 0